import { Theme } from "src/app/shared/services/theme/theme";

export const environment = {
  production: false,
  defaultTheme: 'light' as Theme,
  apiBaseUrl: 'https://locamais.app.br:3000/v1',
  supportUrl: 'mailto:suporte@locamob.com'
};
